import Breadcrumbs from '@components/Breadcrumbs';
import Collapse from '@components/Collapse';
import Container from '@components/UI/Container';
import Link from '@components/UI/Link';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';

import { Navigation } from "@layouts/NavigationV2"

import { React, Fragment } from 'react';

const LinkCNoFollow = ({ href, children }) => <Link href={href} mods={{ violet: true }} target='_blank' linkProps={{rel:'noopener noreferrer nofollow'}}>{children}</Link>;

const CookieTree = () => {

    const data = [
        {
            title: 'Analytics cookies',
            subTitle: '(User Insights & Performance Measurement Tools)',
            purpose: 'these tools collect anonymized data to understand how users interact with the website',
            function: 'they help us analyze user behavior, measure site performance, and improve content, design, and user experience',
            influence: 'without these tools, we may not be able to identify issues, optimize the website, or understand how people engage with our services',
            desc: [
                'These tools do not collect personally identifiable information unless explicitly consented.',
            ],
            cookies: [
                {
                    title: 'Google Analytics cookies',
                    purpose: 'web analytics service',
                    function: 'tracks and reports website traffic and user interactions to understand behavior and improve performance',
                    influence: 'enable insights into user engagement, conversion paths, and performance optimization',
                    type: 'analytics',
                    cookies: '_ga, _gid, _gat, _ga_, _gac_gb_, _gaexp, _dc_gtm_',
                    privacy_policy: 'https://policies.google.com/privacy',
                    cookie_policy: 'https://policies.google.com/technologies/cookies',
                    desc: []
                },
                {
                    title: 'Ahrefs Pixel cookies',
                    purpose: 'analytics for SEO optimization',
                    function: 'tracks user interactions on the website, collecting data on visited pages and actions to analyze SEO performance',
                    influence: 'helps improve website visibility in search engines and optimize content',
                    type: 'analytics',
                    cookies: '_gcl_au, intercom-device-id-dic5omcp, kd-b0e63e04545035eb',
                    privacy_policy: 'https://ahrefs.com/legal/privacy-policy',
                    cookie_policy: 'https://ahrefs.com/legal/cookie-notice',
                    desc: []
                },
                {
                    title: 'Matomo cookies',
                    purpose: 'web analytics service',
                    function: 'tracks and reports website traffic and user interactions to understand behavior and improve performance',
                    influence: 'enable insights into user engagement, conversion paths, and performance optimization',
                    type: 'analytics',
                    cookies: '_pk_id, _pk_ses, _pk_ref, _pk_cvar',
                    privacy_policy: 'https://matomo.org/privacy-policy/',
                    cookie_policy: 'https://matomo.org/privacy-policy/cookies/',
                    desc: []
                },
            ],
        },
        {
            title: 'Advertising cookies',
            subTitle: '(Ad Personalization & Offers Tools)',
            purpose: 'these tools enable the delivery of personalized advertising based on user interests and behavior',
            function: 'they track ad interactions, measure campaign effectiveness, and help show you more relevant ads across platforms',
            influence: 'disabling these tools may lead to seeing less relevant ads and reduced campaign performance measurement',
            desc: [
                'Some of these tools may involve cross-site tracking and require your explicit consent.'
            ],
            cookies: [
                {
                    title: 'Conversion Linker cookies',
                    purpose: 'conversion tracking service',
                    function: 'helps store ad click information to ensure proper attribution for conversions',
                    influence: 'improves the accuracy of Google Ads conversion tracking',
                    type: 'advertising',
                    cookies: '_gcl_au, _gcl_aw, _gcl_dc, _gcl_gb, _gcl',
                    privacy_policy: 'https://policies.google.com/technologies/partner-sites',
                    cookie_policy: 'https://policies.google.com/technologies/cookies?hl=en',
                    desc: []
                },
                {
                    title: 'DoubleClick cookies',
                    purpose: 'advertising service',
                    function: 'manages display ads, retargeting, and measures ad performance across platforms',
                    influence: 'tracks ad interactions and optimizes ad delivery',
                    type: 'advertising',
                    cookies: 'IDE, test_cookie, id, DSID, FLC, RUL, AID',
                    privacy_policy: 'https://policies.google.com/technologies/ads',
                    cookie_policy: 'https://policies.google.com/technologies/cookies',
                    desc: []
                },
            ]
        },
        {
            title: 'Functional cookies',
            purpose: 'these services enhance your experience by enabling non-essential but helpful website feature',
            function: 'includes embedded media, social sharing, fonts, interactive elements, security checks (like CAPTCHA), tag management systems, and third-party libraries',
            influence: 'if disabled, some content (like videos or social buttons) may not display or function properly',
            desc: [],
            cookies: [
                {
                    title: 'Google Tag Manager cookies',
                    purpose: 'tag management system',
                    function: 'manages and loads other tags (marketing, analytics, functional) without modifying code directly',
                    influence: 'facilitates deployment of scripts while ensuring performance and control over data collection',
                    type: 'functional',
                    cookies: 'gtm_debug, gtm_preview, gtm_auth, dc_gtm',
                    privacy_policy: 'https://policies.google.com/privacy',
                    cookie_policy: 'https://policies.google.com/technologies/cookies?hl=en',
                    desc: []
                },
                {
                    title: 'Google AJAX Libraries cookies',
                    purpose: 'performance & functionality',
                    function: 'provides common JavaScript libraries (like jQuery, AngularJS) via Google’s CDN',
                    influence: 'improves website speed and ensures stability of web apps',
                    type: 'functional',
                    cookies: '',
                    privacy_policy: 'https://policies.google.com/privacy',
                    cookie_policy: '',
                    desc: []
                },
                {
                    title: 'Google Fonts cookies',
                    purpose: 'font rendering and styling',
                    function: "Google Fonts loads web fonts from Google's servers to ensure consistent typography and fast rendering across browsers and devices",
                    influence: 'enhances visual appearance and readability; fallback fonts may affect layout and design consistency',
                    type: 'functional',
                    cookies: '',
                    privacy_policy: 'https://policies.google.com/privacy',
                    cookie_policy: '',
                    desc: []
                },
                {
                    title: 'Google Play cookies',
                    purpose: 'app & media linking',
                    function: 'embeds or links to apps and content hosted on the Google Play Store',
                    influence: 'may collect data when interacting with or embedding app store content',
                    type: 'functional',
                    cookies: 'NID, ANID, SID, HSID, SSID, APISID, SAPISID, SIDCC, 1P_JAR, CONSENT, DV, UULE, OGPC, AID, OTZ, __Secure-3PAPISID, __Secure-3PSID, __Secure-3PSIDCC',
                    privacy_policy: 'https://policies.google.com/privacy',
                    cookie_policy: 'https://policies.google.com/technologies/cookies?hl=en',
                    desc: []
                },
                {
                    title: 'YouTube Video cookies',
                    purpose: 'embedded video content service',
                    function: 'displays YouTube videos directly on the site and may collect user data and track engagement',
                    influence: 'allows video viewing and can trigger tracking for YouTube/Google Ads',
                    type: 'functional',
                    cookies: 'VISITOR_INFO1_LIVE, YSC, PREF, GPS, CONSENT, LOGIN_INFO, SID, HSID, SSID, APISID, SAPISID, SIDCC, __Secure-3PAPISID, __Secure-3PSID, __Secure-3PSIDCC',
                    privacy_policy: 'https://policies.google.com/privacy',
                    cookie_policy: 'https://policies.google.com/technologies/cookies?hl=en',
                    desc: []
                },
                {
                    title: 'LinkedIn Social Plugins cookies',
                    purpose: 'social media integration',
                    function: 'allows LinkedIn content (e.g., share buttons, profiles) to be embedded on the site',
                    influence: 'tracks user interaction and may share data with LinkedIn',
                    type: 'functional',
                    cookies: 'bcookie, bscookie, lidc, lang, li_gc, li_mc, liap, lissc, UserMatchHistory, AnalyticsSyncHistory, li_sugr, JSESSIONID, li_fat_id',
                    privacy_policy: 'https://www.linkedin.com/legal/privacy-policy',
                    cookie_policy: 'https://www.linkedin.com/legal/cookie-policy',
                    desc: []
                },
                {
                    title: 'Facebook Social Plugins cookies',
                    purpose: 'social media analytics tool',
                    function: 'allows users to interact with Facebook content from the website (e.g., like or share buttons)',
                    influence: 'tracks user interactions for Facebook analytics and engagement',
                    type: 'functional',
                    cookies: '_fbp, datr, fr, c_user, xs',
                    privacy_policy: 'https://www.facebook.com/policy.php',
                    cookie_policy: 'https://www.facebook.com/policies/cookies/',
                    desc: []
                },
                {
                    title: 'X Social Plugins cookies',
                    purpose: 'social media integration',
                    function: 'allows X content (e.g., X buttons, Follow buttons, embedded timelines) to be embedded on the site',
                    influence: 'tracks user interaction and may share data with X',
                    type: 'functional',
                    cookies: 'guest_id, personalization_id, _twitter_sess, ct0, auth_token',
                    privacy_policy: 'https://x.com/en/privacy',
                    cookie_policy: 'https://help.x.com/en/rules-and-policies/x-cookies',
                    desc: []
                },
                {
                    title: 'Gravatar cookies',
                    purpose: 'profile image management',
                    function: 'shows user avatars based on email address via WordPress and associated platforms',
                    influence: 'associates identities across sites that use Gravatar (owned by Automattic)',
                    type: 'functional',
                    cookies: 'gravatar*, __qca',
                    privacy_policy: 'https://automattic.com/privacy/',
                    cookie_policy: 'https://automattic.com/cookies/',
                    desc: []
                },
                {
                    title: 'StackOverflow cookies',
                    purpose: 'embedding questions, answers, and widgets from StackOverflow',
                    function: 'displays external content and tracks user interactions with embedded widgets; may set cookies for analytics and user preferences',
                    influence: 'improves user experience by integrating relevant community content and discussion',
                    type: 'functional',
                    cookies: 'OptanonConsent, OptanonAlertBoxClosed, acct, prov, s',
                    privacy_policy: 'https://stackoverflow.com/legal/privacy-policy',
                    cookie_policy: 'https://stackoverflow.com/legal/cookie-policy',
                    desc: []
                },
            ]
        },
        {
            title: 'Essential service cookies',
            purpose: 'these tools and scripts are required for the website to function securely and properly',
            function: 'includes security checks (like CAPTCHA), tag management systems, and basic content delivery (CDNs)',
            influence: 'cannot be disabled as they are crucial for stability, performance, and protection against fraud or abuse',
            desc: [],
            cookies: [
                {
                    title: 'JSDelivr cookies',
                    purpose: 'content delivery network (CDN)',
                    function: 'serves JavaScript libraries and assets quickly from distributed servers',
                    influence: 'enhances site performance and reduces load times',
                    type: 'functional',
                    cookies: '',
                    privacy_policy: 'https://www.jsdelivr.com/terms/privacy-policy',
                    cookie_policy: '',
                    desc: []
                },
                {
                    title: 'gstatic.com cookies',
                    purpose: 'Google static content delivery',
                    function: 'delivers static resources such as fonts, libraries, and scripts used by Google services',
                    influence: 'boosts performance and reliability of embedded Google elements',
                    type: 'functional',
                    cookies: 'rc::a, rc::b, rc::c, _GRECAPTCHA',
                    privacy_policy: 'https://policies.google.com/privacy',
                    cookie_policy: 'http://www.google.com/intl/de/policies/privacy/',
                    desc: []
                },
                {
                    title: 'reCAPTCHA cookies',
                    purpose: 'security & bot prevention service',
                    function: 'protects forms and website functionality by distinguishing human users from bots',
                    influence: 'ensures secure and legitimate usage of forms and login areas',
                    type: 'functional',
                    cookies: 'NID, ANID, 1P_JAR, CONSENT, DV, OTZ, AEC, __Secure-ENID, __Secure-3PAPISID, __Secure-3PSID, __Secure-3PSIDCC, SID, HSID, SSID, APISID, SAPISID',
                    privacy_policy: 'https://policies.google.com/privacy',
                    cookie_policy: 'https://policies.google.com/technologies/cookies?hl=en',
                    desc: []
                },
                {
                    title: 'Cloudflare cookies',
                    purpose: 'website security and performance optimization',
                    function: 'provides DDoS protection, content delivery network (CDN) services, and performance improvements; may set cookies to verify users are not bots',
                    influence: 'enhances site security, reliability, and load speed',
                    type: 'functional',
                    cookies: '__cf_bm, cf_clearance, __cfruid',
                    privacy_policy: 'https://www.cloudflare.com/privacypolicy/',
                    cookie_policy: 'https://www.cloudflare.com/privacypolicy/',
                    desc: []
                },
                {
                    title: 'traqq.com cookies',
                    purpose: 'Traqq analytics service',
                    function: "uses own cookies to identify the user and session, protect from CSRF, and confirm consent for cookies; data is not shared with third parties and is stored only on Traqq’s servers",
                    influence: 'increase the accuracy of traffic source tracking using a server and reduce the likelihood of losing information about the source of a transaction',
                    type: 'functional',
                    cookies: '_trq_cmp, _trq_cpage, _trq_url, trqutm',
                    privacy_policy: 'https://traqq.com/legal/privacy',
                    cookie_policy: 'https://traqq.com/legal/cookies',
                    desc: []
                }
            ]
        }
    ];

    return (
        data.map((cookieType, i) => {
            return (
                <Fragment>
                    <Heading tag='h3'>{`${i+1}. ${cookieType.title}`}</Heading>
                    {cookieType.subTitle && <Paragraph tag='p' className={"-mt-4"}>
                        {cookieType.subTitle}
                    </Paragraph>}
                    {cookieType.purpose && <Paragraph tag='p'>Purpose: {cookieType.purpose}</Paragraph>}
                    {cookieType.function && <Paragraph tag='p'>Function: {cookieType.function}</Paragraph>}
                    {cookieType.influence && <Paragraph tag='p'>Influence: {cookieType.influence}</Paragraph>}
                    {cookieType.type && <Paragraph tag='p'>Type: {cookieType.type}</Paragraph>}
                    {cookieType.desc && cookieType.desc.map((el, i) => <p key={i} className='paragraph !text-base'>{el}</p>)}

                    {cookieType.cookies && cookieType.cookies.map((cookie, i) =>
                        <Collapse key={i} title={cookie.title} className='mb-2'>
                            {cookie.purpose && <Paragraph tag='p'>Purpose: {cookie.purpose}</Paragraph>}
                            {cookie.function && <Paragraph tag='p'>Function: {cookie.function}</Paragraph>}
                            {cookie.influence && <Paragraph tag='p'>Influence: {cookie.influence}</Paragraph>}
                            {cookie.type && <Paragraph tag='p'>Type: {cookie.type}</Paragraph>}
                            {cookie.cookies && <Paragraph tag='p'>
                                Cookie used: <span className={"text-slate-blue-500"}>{cookie.cookies}</span>
                            </Paragraph>
                            }
                            {cookie.privacy_policy &&
                                <Paragraph tag='p'>
                                    <LinkCNoFollow href={cookie.privacy_policy}>Privacy policy</LinkCNoFollow>
                                </Paragraph>
                            }
                            {cookie.cookie_policy &&
                            <Paragraph tag='p'>
                                <LinkCNoFollow href={cookie.cookie_policy}>Cookie policy</LinkCNoFollow>
                            </Paragraph>
                            }
                            {cookie.desc && cookie.desc.map((el, i) => <p key={i} className='paragraph !text-base'>{el}</p>)}
                        </Collapse>
                    )
                    }
                </Fragment>
            )
        })
    )
};

const CookiePolicy = () => (
    <>
        <Navigation
            staticTheme="light"
            actionTheme="light"
        />

        <Breadcrumbs
            wrap
        />

        <div
            className='legal legal_list_disk'
        >
            <Container>
                <Heading tag='h1'>
                    Cookie Policy
                </Heading>

                <Paragraph tag='p' className={"mt-8"}>
                    Cookies are small text files stored on a user’s device by websites they visit, primarily to enhance browsing efficiency and personalize user experiences. They can remember login details, preferences, and shopping cart contents, making repeated visits more convenient.
                </Paragraph>
                <Paragraph tag='p'>
                    Cookies can be managed directly through your browser settings, where you can choose how they are stored and used (more details here: <LinkCNoFollow href={"https://aboutcookies.org/"}>aboutcookies.org</LinkCNoFollow>). Most browsers allow you to accept or reject cookies, enable them only for specific websites, or set notifications before a cookie is placed. You can also delete cookies at any time or configure your browser to automatically remove them after a session. These options give you flexibility in tailoring your browsing experience while continuing to enjoy the functionality and convenience that cookies provide.
                </Paragraph>
                <Paragraph tag='p'>
                    Cookies help us gather information about how our website is used. Such data may include:
                </Paragraph>
                <ul>
                    <li>the type of internet browser</li>
                    <li>the operating system</li>
                    <li>the domain of the website through which you accessed our platform</li>
                    <li>the date and time of your visit</li>
                    <li>the length of your session</li>
                    <li>the number of times you visit</li>
                    <li>the average time spent on our website</li>
                    <li>and the average time spent on individual pages you view</li>
                </ul>
                <Paragraph tag='p' className={"mt-4"}>
                    Each cookie also contains a unique identifier linked to your browser, which allows us to recognize it when you return to our website.
                </Paragraph>
                <Paragraph tag='p'>
                    For analytic, functional and marketing purposes, we utilize both first-party and third-party cookies.
                </Paragraph>

                <CookieTree />

                <Paragraph tag='p' mods={{ semibold: true }} className={"mt-8"}>
                    By continuing to browse this site, you are agreeing to our use of cookies.
                </Paragraph>
            </Container>
        </div>
    </>
);

export default CookiePolicy;
